'use strict';

angular.module('menu', [
    'inetsys.modal',
    'user',
]);
